import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=fca54416&scoped=true&"
import script from "./SubCategories.vue?vue&type=script&lang=js&"
export * from "./SubCategories.vue?vue&type=script&lang=js&"
import style0 from "./SubCategories.vue?vue&type=style&index=0&id=fca54416&lang=scss&scoped=true&"
import style1 from "./SubCategories.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./SubCategories.vue?vue&type=style&index=2&id=fca54416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca54416",
  null
  
)

export default component.exports